var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown-inactive",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33486",
    "data-name": "Path 33486",
    d: "M139.58,21.744a1,1,0,0,0-1.312,0l-2.592,2.324-2.592-2.324a1,1,0,0,0-1.312,0,.772.772,0,0,0,0,1.177l3.248,2.913a1,1,0,0,0,1.312,0l3.248-2.913A.772.772,0,0,0,139.58,21.744Z",
    transform: "translate(-119.955 -8.019)",
    fill: "#777e91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3774",
    "data-name": "Rectangle 3774",
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "none",
    stroke: "#e6e8ec",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowIcon);
export default __webpack_public_path__ + "static/media/whiteArrowIcon.65b8d7fb8a44b45bdc1ae1a5822eccc7.svg";
export { ForwardRef as ReactComponent };